import Layout from '@/layout'

const route = {
  path: '/security',
  component: Layout,
  redirect: '/security/index',
  alwaysShow: true, // will always show the root menu
  name: 'Security',
  meta: {
    title: 'security',
    icon: 'el-icon-document-checked',
    roles: [
      'larke-admin.security.index'
    ]
  },
  sort: 110080,
  children: [
    // 安全检验报告
    {
      path: '/security/index',
      component: () => import('@/views/verification/Components/Security'),
      name: 'SecurityIndex',
      meta: {
        title: 'securityIndex',
        icon: 'el-icon-tickets',
        roles: [
          'larke-admin.security.index'
        ]
      }
    }
  ]
}

export default route
